import { createStore } from 'vuex';
import axios from 'axios';

// Relative base: requests are same-origin (Vite proxy in dev, nginx in prod),
// so the session cookie is sent automatically.
const BACKEND_HOST = '';

const store = createStore({
  state: {
    isAuthenticated: false,
    user: null,
    userId: null,
    role: null,
    isAdmin: false,
    isTeacher: false,
    isAssistant: false,
    isDancer: false,
    childId: [],
  },
  mutations: {
    LOGIN(state, userData) {
      state.isAuthenticated = true;
      state.user = userData.user;
      state.userId = userData.userId;
      state.role = userData.role;
      state.isAdmin = userData.isAdmin;
      state.childId = userData.childId;
      state.isTeacher = userData.isTeacher;
      state.isAssistant = userData.isAssistant;
      state.isDancer = userData.isDancer;
    },
    LOGOUT(state) {
      state.isAuthenticated = false;
      state.user = null;
      state.userId = null;
      state.role = null;
      state.isAdmin = false;
      state.childId = [];
      state.isTeacher = false;
      state.isAssistant = false;
      state.isDancer = false;
    },
  },
  actions: {
    async login({ commit }, credentials) {
      try {
        const response = await axios.post(BACKEND_HOST + '/api/login', credentials);
        const userData = {
          user: response.data.user,
          userId: response.data.user_id,
          role: response.data.role,
          isAdmin: response.data.isAdmin,
          childId: response.data.childId,
          isTeacher: response.data.isTeacher,
          isAssistant: response.data.isAssistant,
          isDancer: response.data.isDancer,
        };
        commit('LOGIN', userData);
        
        // Store childId as a JSON string
        localStorage.setItem('user', response.data.user);
        localStorage.setItem('userId', response.data.user_id);
        localStorage.setItem('role', response.data.role);
        localStorage.setItem('isAdmin', response.data.isAdmin);
        localStorage.setItem('isTeacher', response.data.isTeacher);
        localStorage.setItem('isAssistant', response.data.isAssistant);
        localStorage.setItem('isDancer', response.data.isDancer);

        localStorage.setItem('childId', JSON.stringify(response.data.childId)); // Convert to JSON string
        
        return userData;
      } catch (err) {
        throw new Error(err.response?.data?.message || 'Login failed');
      }
    },
    async logout({ commit }) {
      try {
        await axios.get(BACKEND_HOST + '/api/logout');
        localStorage.removeItem('user');
        localStorage.removeItem('userId');
        localStorage.removeItem('role');
        localStorage.removeItem('isAdmin');
        localStorage.removeItem('isTeacher');
        localStorage.removeItem('isAssistant');
        localStorage.removeItem('isDancer');
        localStorage.removeItem('childId');
        commit('LOGOUT');
      } catch (err) {
        console.error('Logout failed', err);
        // Even if logout fails on server, clear local state
        localStorage.removeItem('user');
        localStorage.removeItem('userId');
        localStorage.removeItem('role');
        localStorage.removeItem('isAdmin');
        localStorage.removeItem('isTeacher');
        localStorage.removeItem('isAssistant');
        localStorage.removeItem('isDancer');
        localStorage.removeItem('childId');
        commit('LOGOUT');
      }
    },
    checkAuth({ commit }) {
      const user = localStorage.getItem('user');
      const userId = localStorage.getItem('userId');
      const role = localStorage.getItem('role');
      const isAdmin = localStorage.getItem('isAdmin') === 'true';
      const isTeacher = localStorage.getItem('isTeacher') === 'true';
      const isAssistant = localStorage.getItem('isAssistant') === 'true';
      const isDancer = localStorage.getItem('isDancer') === 'true';
      const childId = localStorage.getItem('childId');
      // Parse childId from localStorage (if it exists) and ensure it's an array or object
      const parsedChildId = childId ? JSON.parse(childId) : [];

      if (user) {
        commit('LOGIN', { user, userId, role, isAdmin, childId: parsedChildId, isTeacher, isAssistant, isDancer });
      }
    },

  },
  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    isAdmin: (state) => state.isAdmin,
    isTeacher: (state) => state.isTeacher,
    isAssistant: (state) => state.isAssistant,
    isDancer: (state) => state.isDancer,
    role: (state) => state.role,
    childId: (state) => state.childId,
    userId: (state) => state.userId,
  },
});

export default store;
